/** @jsx jsx */
import { jsx } from '@emotion/react'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import ButtonSubmit from '../buttons/ButtonSubmit'
import ModalLogin from '../modals/ModalLogin'
import ModalRegisterForAccess from '../modals/ModalRegisterForAccess'
import { GlobalContext } from '../misc/GlobalContextProvider'
import { ModalsContext } from '../modals/Modals'
import { mq } from '../../theme'

const AboutUsCTAButtons: React.FC = () => {
  const modalsCtx = useContext(ModalsContext)
  const ctx = useContext(GlobalContext)

  if (!modalsCtx || !ctx) {
    return null
  }

  if (!!ctx.currentProfile) {
    return (
      <Link to="/en/u/">
        <ButtonSubmit variant="inverted" css={[mq('mr1'), mq('mb1')]}>
          Open Dashboard
        </ButtonSubmit>
      </Link>
    )
  }

  return (
    <div>
      <ButtonSubmit
        variant="inverted"
        css={[mq('mr1'), mq('mb1')]}
        onClick={() => {
          if (!!modalsCtx) {
            modalsCtx.show(<ModalLogin />)
          }
        }}
      >
        Log In
      </ButtonSubmit>
    </div>
  )
}

export default AboutUsCTAButtons
